// extracted by mini-css-extract-plugin
export default {"holidayCalendarItem":"OubjXuUUb1tSZgBRKQmx","bounce":"ncMMqASWqjQlbHsBaCQo"};